export * from './trackEvent';
export * from './trackClarityEvent';

declare global {
  interface Window {
    dataLayer: Array<{ event?: string; [key: string]: unknown }>;
    clarity?: (method: string, ...args: Array<string>) => void;
  }
}
